import type { Config } from 'tailwindcss';
import colors from 'tailwindcss/colors';

export default {
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
  theme: {
    colors: {
      grey: colors.gray,
      slate: colors.slate,
    },
    extend: {
      fontFamily: {
        sans: ['Inter', 'ui-sans-serif', 'system-ui', 'sans-serif'],
      },
      backgroundImage: {
        'default-gradient': 'url(./../public/images/gradient-1_sm.png)',
        grad: 'linear-gradient(135deg, #ff7a45, #ef4823)',
        'grad-vertical': 'linear-gradient(180deg, #ff8a52, #ef4823)',
        'grad-cool': 'linear-gradient(90deg, #6366f1, #0fb5cf)',
        'aurora-mesh':
          'radial-gradient(1450px 860px at 10% -2%, rgba(255, 164, 101, 0.65), transparent 56%), radial-gradient(1200px 1400px at 71% -4%, rgb(140 226 198 / 57%), transparent 54%), radial-gradient(1200px 960px at 18% 66%, rgba(214, 160, 242, 0.74), transparent 56%), radial-gradient(1300px 980px at 86% 104%, rgba(138, 180, 255, 0.88), transparent 56%), radial-gradient(980px 800px at 56% 30%, rgba(255, 168, 196, 0.62), transparent 55%), linear-gradient(rgb(236, 238, 245), rgb(230, 234, 243))',
        'header-aurora':
          'linear-gradient(110deg,hsla(26.7,74%,96.7%,.68),hsla(216,66%,98%,.36) 26%,hsla(280,34%,98%,.82) 78%,hsla(210,45%,97.5%,.86))',
        'rail-aurora':
          'linear-gradient(180deg,hsla(26.7,68%,97%,.84),hsla(216,58%,98%,.62) 26%,hsla(280,30%,98%,.8) 78%,hsla(210,40%,97.5%,.84))',
      },
      borderRadius: {
        lg: '0.5rem',
        xl: '0.75rem',
        '2xl': '1rem',
        '3xl': '1.5rem',
      },
      boxShadow: {
        card: '0px 4px 16px hsla(0, 0%, 0%, 0.04)',
        'pop-up': '0px 4px 10px 0px hsla(0,0%,0%,0.15)',
        dialog: '0px 6px 15px 0px hsla(0,0%,0%,0.2)',
        sidebar: '0px 4px 20px 0 hsla(0,0%,0%,10%)',
        header: '0px 1px 8px 0 hsla(0,0%,0%,10%)',
        orange: '0px 4px 12px hsla(16, 100%, 61%, 0.4)',
        'orange-card': '0px 6px 12px hsla(16, 100%, 71%, 0.25)',
        'orange-chip': '0px 3px 8px hsla(16 100% 70% / 0.5)',
        glass:
          '0 32px 84px -28px rgba(70,60,90,.32), 0 2px 10px rgba(70,60,90,.06)',
        'aurora-card':
          '0 1px 2px rgba(40,30,30,.04), 0 14px 34px -16px rgba(60,50,60,.12)',
        'header-aurora': '0px 2px 12px hsla(215,22%,64%,.3)',
      },
      transitionProperty: {
        width: 'width',
      },
      colors: {
        transparent: 'transparent',
        white: '#fff',
        black: '#1b2932',
        // 'site-background': '#f8f9fa',
        'site-background': '#fafafb',
        'dialog-backdrop': '#15181C',
        taupe: {
          1: '#938b80',
          2: '#5f5a52',
          3: '#1a1510',
        },
        accent: {
          gradientStart: '#ff8a52',
          gradientEnd: '#ef4823',
          teal: '#0fb5cf',
          tealGradientStart: '#3fd0e6',
          tealGradientEnd: '#0fb5cf',
          indigo: '#6366f1',
          amber: '#f59e0b',
          positive: '#159f6a',
          negative: '#df2a20',
        },
        brand: {
          blue: '#002255',
          orange: '#ff9068',
          accent: '#f15a2b',
        },
        blue: {
          1: '#E1EFF9',
          2: '#10a2fd',
          3: '#357dd2',
          4: '#255fb0',
          ...colors.blue,
        },
        cyan: {
          1: '#DBF5F7',
          2: '#22d3ee',
          3: '#06b6d4',
          4: '#0e7490',
        },
        emerald: {
          1: '#E4F9F0',
          2: '#6ee7b7',
          3: '#34d399',
          4: '#059669',
        },
        green: {
          1: '#b4f3cf',
          2: '#58bd85',
          3: '#4aa37f',
          4: '#3a8474',
        },
        lime: {
          1: '#d9f99d',
          2: '#bef264',
          3: '#a3e635',
          4: '#84cc16',
        },
        navy: {
          1: '#6c8fe0',
          2: '#234aa4',
          3: '#1a377a',
          4: '#0c2254',
        },
        orange: {
          1: '#ffd1b7',
          2: '#f97b19',
          3: '#ff6b36',
          4: '#cc4700',
          ...colors.orange,
        },
        pink: {
          1: '#FCE2E5',
          2: '#fb7195',
          3: '#f43f5e',
          4: '#e11d48',
        },
        purple: {
          1: '#869af4',
          2: '#5370f4',
          3: '#475ece',
          4: '#3449ae',
          ...colors.purple,
        },
        red: {
          1: '#feb3af',
          2: '#f2625a',
          3: '#df2a20',
          4: '#bd180f',
        },
        yellow: {
          1: '#fef08a',
          2: '#fde047',
          3: '#facc15',
          4: '#eab308',
        },
        grey: {
          1: '#fafafa',
          // 2: '#f8f9fc',
          2: '#f3f5f7',
          3: '#e2e6e9',
          4: '#cedfe8',
          5: '#a7c1d2',
          6: '#7e9eb5',
          7: '#496f88',
          8: '#2d4453',
          9: '#121b21',
        },
      },
    },
  },
  plugins: [],
} satisfies Config;
